/* eslint-disable max-len */
import React, { useState } from 'react'
import TableRow from './tableRow'
import { Link, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import TableHeader from '../../../CommonComponent/ListingScreens/TableHeader';
import NoSearchScreen from '../../../CommonComponent/ListingScreens/NoSearchScreen';
import Modal from '../../../CommonComponent/Modal';
import { dataService } from '../../../services/dataService';
import scrollToTop from '../../../CommonComponent/scrollToTop';
import EmptyScreen from '../../../CommonComponent/ListingScreens/EmptyScreen';
import TableShimmer from '../../../CommonComponent/ListingScreens/TableShimmer';

export default function ListingBody(props) {

    const { auctionData , handleSort, handleAddNote, isFilterApplied, searchParams, auction, loading, currentSortColumn, 
        cloneHandler,isDeleteModalOpen,loader,setIsDeleteModalOpen, isCancelModalOpen,setMessage,setLoader,
        setIsCancelModalOpen,handleFetch, domain, fetchAuctions, setErrorMessage} =props;

    const keyword=`${decodeURIComponent(searchParams.get('keyword')).length>20 ? 
        decodeURIComponent(searchParams.get('keyword')).substring(0,20)+'...' : decodeURIComponent(searchParams.get('keyword'))}`

    const price=useSelector((state)=>state.pricingSlice)
    const [auctionInfo, setAuctionInfo] = useState({})
    const user = (localStorage.getItem('user'));

    /**
     * The addNoteHandler function calls the handleAddNote function with the provided auction_id and
     * note parameters.
     */
    const addNoteHandler=(auction_id,note)=>{
        handleAddNote(auction_id,note)
    }

    const auctionColumns = [
        { label: "Auction ID", testId: "title", minWidth: "115px" },
        { label: "Type", sortKey: "auction_type", testId: "auction_type", minWidth: "110px", center: true },
        { label: "", minWidth: "120px" },
        { label: "Name", sortKey: "title", testId: "auction_name", minWidth: "120px", maxWidth: '200px', center: true },
        { label: "Start Date", sortKey: "start_date", minWidth: "140px", center: true },
        { label: "End Date", sortKey: "end_date", minWidth: "140px", center: true },
        { label: "Status", sortKey: "status", testId: "auction_status", minWidth: "160px", maxWidth: "180px", center: true },
        { label: "", minWidth: "60px", responsiveMinWidth: "20px" },
        { label: "", minWidth: "50px", responsiveMinWidth: "70px" },
    ];

    const handleDelete = async()=>{
        setLoader(true)
        const isLive = auctionInfo?.auction_type === 'live';
        const data = await dataService.DeleteAuction(auctionInfo.auction_id, isLive)
        if(data.error===false){
            setLoader(false)
            setIsDeleteModalOpen(false)
            setMessage('Auction has successfully been deleted');
            setTimeout(() => {
                setMessage('')
            }, 4000);
            handleFetch()
            scrollToTop();
        }
    }

    const handleCancel = async()=>{
        setLoader(true)
        let response = {};
        if(auctionInfo.auction_type==="live"){
            const body = {
                "auction_id": auctionInfo.auction_id,
                "seller_email": user
            }
            response = await dataService.CancelAuction(body);
        }else{
            const body={
                "type": "CANCEL"
            }
            response = await dataService.UnpublishAuction(auctionInfo.auction_id,body);
        }
        setLoader(false)
        setIsCancelModalOpen(false)
        if(response.error===false){
            setMessage('Auction has been successfully deleted');
            setTimeout(() => {
                setMessage('')
            }, 4000);
            handleFetch()
            scrollToTop();
        }else{
            if(response?.message && response.message.status==400){
                setErrorMessage(response?.message?.data?.message)
            }else{
                setErrorMessage('Something went wrong. Please try again')
            }
            setTimeout(()=>{
                setErrorMessage("")
            },4000)
        }
    }

    return (
        <>
            <div className='pb-[200px] z-10 pt-2 overflow-x-auto customScrollbar'>
                <table aria-label="Outside Table" className="w-full table-auto border-[#DEDEDE] border rounded-lg"
                    style={{borderCollapse: 'separate', borderSpacing: 0}}>
                    <TableHeader columns={auctionColumns} handleSort={handleSort} currentSortColumn={currentSortColumn} />
                    {/* <!-- empty auction list --> */}
                    {(auctionData.length===0 && isFilterApplied!==true && searchParams.get('keyword')=== null && !loading) &&
                    <tbody>
                        <tr>
                            <td colSpan="7" className="sm:text-center text-start sm:pl-0 xs:pl-[200px] pl-[100px]">
                                <div className="h-[200px] mt-[100px]">
                                    <p className="text-[18px] font-medium  leading-normal text-[#34343">Currently no auctions</p>
                                    {(auction.total_pages===0) &&  
                                    <Link to={price.plan_type=="Pro" ? '/auctions/type' : `/auctions/timed/create`}>
                                        <button className="px-[31px] mt-2 py-[12px] bg-[#282828] 
                                    sm:mx-0 mx-3 text-[#FFFFFF] leading-normal font-medium text-[14px] rounded-[6px] 
                                    hover:bg-[#3F3F45]">
                                            Create auction
                                        </button>
                                    </Link>}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    }
                    {/* <!-- empty search  --> */}
                    {(searchParams.get('keyword')!== null && auctionData.length===0 && isFilterApplied===false && !loading) && 
                    <NoSearchScreen searchValue={keyword} cols={8} />}
                    {(searchParams.get('keyword')!== null && isFilterApplied===true && auctionData.length===0 && !loading) && 
                    <   EmptyScreen message="No results found" cols={8} />
                    }
                    {/* <!-- empty filter --> */}
                    {(isFilterApplied===true && auctionData.length===0 && searchParams.get('keyword')=== null && !loading ) && 
                    <EmptyScreen message="No results for applied filter" cols={8} />
                    }
                    {loading && <TableShimmer columns={auctionColumns} rowCount={5}/>}
                    {!loading && <tbody className="mt-5">
                        {auctionData.map((auction, index)=><TableRow
                            key={index} auction={auction}
                            index={index}
                            domain={domain} fetchAuctions={fetchAuctions}
                            addNoteHandler={addNoteHandler}
                            cloneHandler={cloneHandler}
                            setMessage={setMessage}
                            loader={loader}                            
                            setIsDeleteModalOpen={setIsDeleteModalOpen}
                            handleFetch={handleFetch}
                            setAuctionInfo={setAuctionInfo}
                            auctionInfo={auctionInfo}
                            setIsCancelModalOpen={setIsCancelModalOpen}
                            setErrorMessage={setErrorMessage} />)
                        }
                    </tbody>}
                </table>
            </div>


            <Modal setIsOpen={setIsDeleteModalOpen} isOpen={isDeleteModalOpen} handleAction={handleDelete} loading={loader} 
                buttonText="Delete" id="delete-button" close={false} notShowCancel={false}
                title="Are you sure you want to delete the auction?"
                description="Please note that deleting the auction will also delete all lots within the auction. This action cannot be reversed."
            />
            
            <Modal setIsOpen={setIsCancelModalOpen} isOpen={isCancelModalOpen} handleAction={handleCancel} loading={loader} 
                buttonText="Cancel auction" id="cancel-button" close={true} notShowCancel={true}
                title="Are you sure you want to cancel the auction?"
                description="Please note that cancelled auctions cannot be re-published. All bidder and bids data will be retained."
            />
        </>
    )
}
